var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class CustomerCartService {
    constructor(apiRoot, projectKey) {
        this.apiRoot = apiRoot;
        this.projectKey = projectKey;
    }
    getActiveCart() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .me()
                .activeCart()
                .get()
                .execute();
            return response.body;
        });
    }
    createCart(customer) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const body = { currency: "EUR" };
            if (customer === null || customer === void 0 ? void 0 : customer.defaultShippingAddressId) {
                const address = (_a = customer.addresses) === null || _a === void 0 ? void 0 : _a.find((a) => a.id === customer.defaultShippingAddressId);
                if (address === null || address === void 0 ? void 0 : address.country)
                    body.country = address.country;
            }
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .me()
                .carts()
                .post({ body })
                .execute();
            return response.body;
        });
    }
    updateCart(cartId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .me()
                .carts()
                .withId({ ID: cartId })
                .post({ body: payload })
                .execute();
            return response.body;
        });
    }
    changeLineItemQuantity(cartId, version, lineItemId, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                version,
                actions: [
                    {
                        action: "changeLineItemQuantity",
                        lineItemId,
                        quantity,
                    },
                ],
            };
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .me()
                .carts()
                .withId({ ID: cartId })
                .post({ body: payload })
                .execute();
            return response.body;
        });
    }
    addDiscountCode(cartId, version, code) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                version,
                actions: [
                    {
                        action: "addDiscountCode",
                        code,
                    },
                ],
            };
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .me()
                .carts()
                .withId({ ID: cartId })
                .post({ body: payload })
                .execute();
            return response.body;
        });
    }
    removeDiscountCode(cartId, version, discountCodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                version,
                actions: [
                    {
                        action: "removeDiscountCode",
                        discountCode: {
                            typeId: "discount-code",
                            id: discountCodeId,
                        },
                    },
                ],
            };
            const response = yield this.apiRoot
                .withProjectKey({ projectKey: this.projectKey })
                .me()
                .carts()
                .withId({ ID: cartId })
                .post({ body: payload })
                .execute();
            return response.body;
        });
    }
}
